<template>
  <div class="wrap">
    <div class="box">
      <div class="revenue-header">
        <!-- <div class="seach-box">
          <span class="time">时间</span>
          <div class="select">
            <el-select v-model="seachCondition.quarter" placeholder="请选择">
              <el-option
                v-for="item in quarterList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-date-picker
              v-model="seachCondition.date"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
          <el-button @click="seachData" type="primary" style="margin-left:10px"
            >查询</el-button
          >
        </div> -->
      </div>
      <div class="revenue-main" v-if="data && dataYear">
        <div class="revenue-main-show">
          <div class="show-box">
            <div class="show-box-title">当月支出</div>
            <div class="show-box-money">{{ data.expend.total }}</div>
          </div>
          <div class="show-box">
            <div class="show-box-title">当年支出</div>
            <div class="show-box-money">{{ dataYear.expend.total }}</div>
          </div>
       
        </div>
        <div class="revenue-chart">
          <div class="chart-box">
            <div class="chart-box-item">
              <div class="item-title">当月托管收支情况</div>
              <Echarts :datas="data" kid="incomeAndExpendData"></Echarts>
            </div>
          </div>
          <div class="chart-box-item">
            <div class="item-title">当年托管收支总体情况</div>
            <Echarts :datas="dataYear" kid="incomeAndExpendData"></Echarts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Echarts from "@/components/page/definition/echart.vue";
import requesApi from "./index";
export default {
  data() {
    return {
      dataYear:null,
      quarterList: [
        { name: "年", id: "1" },
        { name: "月", id: "2" }
      ],
      seachCondition: {
        quarter: "",
        date: new Date()
      },
      data: null
    };
  },
  components: {
    Echarts
  },
  created() {},
  mounted() {
    this.getData(2, this.seachCondition.date, 0, -1);
    this.getData(1, this.seachCondition.date, 0, -1);
  },
  watch: {},
  methods: {
    seachData() {
      this.getData(
        this.seachCondition.quarter,
        this.seachCondition.date,
        0,
        -1
      );
    },
    getData(dateType, time, companyId, status) {
      let vm = this;
      requesApi
        .getDataForLessee(dateType, time, companyId, status)
        .then(res => {
          console.log(res)
          if(dateType==2) vm.data = res;
          else vm.dataYear = res;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  color: #000000;
  .box {
    width: 100%;
    height: 100%;
    padding: 14px;
    border-radius: 4px;
    box-sizing: border-box;
    background-color: #ffffff;
    box-sizing: border-box;
    .revenue-header {
      .seach-box {
        display: flex;
        align-items: center;
        text-align: left;
        .time {
          margin-right: 10px;
        }
        .select {
          margin-right: 10px;
        }
      }
    }
    .revenue-main {
      margin-top: 10px;
      .revenue-main-show {
        display: flex;
        .show-box {
          background: #eee;
          flex: 1;
          margin-left: 10px;
          padding: 10px;
          border-radius: 4px;
          .show-box-title {
            font-weight: 600;
            text-align: left;
          }
          .show-box-money {
            font-weight: 700;
            font-size: 20px;
            padding-top: 10px;
            padding-bottom: 25px;
          }
          .monrybox {
            display: flex;
            justify-content: space-between;
          }
        }
      }
      .revenue-chart {
        .chart-box {
          display: flex;
          .chart-box-item {
            padding: 10px;
            margin-top: 10px;
            margin-left: 10px;
            background: #eee;
            border-radius: 4px;
            flex: 1;
            .item-title {
              text-align: left;
              font-weight: 600;
              font-size: 16px;
              padding-bottom: 5px;
            }
          }
        }
        .chart-box-item {
          padding: 10px;
          margin-top: 10px;
          margin-left: 10px;
          background: #eee;
          border-radius: 4px;
          flex: 1;
          .item-title {
            text-align: left;
            font-weight: 600;
            font-size: 16px;
            padding-bottom: 5px;
          }
        }
      }
    }
  }
}
.pageNew {
  text-align: right;
  padding: 14px 0px 0px 0px;
}
.nc ::v-deep .el-input {
  width: 197px !important;
}
.ztWrap {
  overflow: hidden;
  white-space: normal;
}
.flexbox {
  display: flex;
}
</style>
